<app-efa-generic-link
  *ngIf="data$ | async as data"
  [url]="data.urlLink"
  [target]="getTarget(data)"
>
  <p class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></p>
  <app-efa-media [container]="data.media"></app-efa-media>
  <p class="content" *ngIf="data.content" [innerHTML]="data.content"></p>
</app-efa-generic-link>
